import { Controller } from "@hotwired/stimulus"

// Onboarding convenience: as a manager fills in their own signing data, the
// same value is mirrored into the matching organization field. Skipped once
// the organization field already holds something, so the copy is only a
// starting point — the user stays free to edit the organization's data
// independently (e.g. its CNPJ legitimately differs from the person's CPF).
export default class extends Controller {
  static targets = [
    "personalLegalId", "personalZip", "personalStreet", "personalNumber",
    "personalComplement", "personalNeighborhood", "personalCity", "personalState",
    "orgLegalId", "orgZip", "orgStreet", "orgNumber",
    "orgComplement", "orgNeighborhood", "orgCity", "orgState"
  ]

  mirror(event) {
    const field = event.params.field
    const source = this[`personal${field}Target`]
    const target = this[`org${field}Target`]
    if (!source || !target || target.value.trim() !== "") return

    const maskCtrl = this.application.getControllerForElementAndIdentifier(target, "mask")
    if (maskCtrl) {
      maskCtrl.setDisplayValue(source.value)
    } else {
      target.value = source.value
    }
  }
}
